// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"y8D8DXYK _3beaI7sm _2cpDdWp- _32cMlxJ_"};